// extracted by mini-css-extract-plugin
export default {"wrapper":"empty_wrapper__3zKRO","container":"empty_container__c1NOJ","title":"empty_title__vZ-Ib"};